export const SUPPRESS_MAP_CLICK_TIME = 250 // ms
